export default __webpack_public_path__ + "static/media/down.2e7d4749.svg";